import React, { useState, useEffect, useRef } from "react";
import {  Modal, Form,  } from "antd";

import {
  GoogleMap,
  Marker,

  Autocomplete,
} from "@react-google-maps/api";

import TextInput from "../../ReusableInputs/TextInput";
import SecondaryButton from "../../Button/SecondaryButton";
import SelectOption from "../../ReusableInputs/SelectOption";
import { Puff } from "react-loader-spinner";
import { useNotification } from "../../Toast/Notification";

const Loader: React.FC = () => {
  return (
    <div className="flex items-left justify-left ">
      <Puff
        visible={true}
        height="60"
        width="60"
        color="#75A7AD"
        ariaLabel="puff-loading"
      />
    </div>
  );
};
interface Coordinates {
  latitude: number;
  longitude: number;
}

interface AddressModalProps {
  visible: boolean;
  onClose: () => void;
  street: string;
  address2: string;
  address3: string;
  addressType: string;
  buildingType: string;
  city: string;
  unitNumber: string;
  province: string;
  postalCode: string;
  suburb: string;
  blockNumber: string;
  blockName: string;
  isProcessing: boolean;
  isModalVisible: boolean;
  address_2: string;
  longitude: number;
  latitude: number;
  place_id: string;
  building_type_name: string;
  street_number: string;
  businessParkOrResidentialComplexName: string;
  buildingNameOrNumber: string;
  blockNameOrNumber: string;
  unitNameOrNumber: string;

  setBusinessParkOrResidentialComplexName: (value: string) => void;
  setBuildingNameOrNumber: (value: string) => void;
  setBlockNameOrNumber: (value: string) => void;
  setUnitNameOrNumber: (value: string) => void;

  setStreetNumber: (value: string) => void;
  setBuilding_type_name: (value: string) => void;
  setAddress_2: (value: string) => void;
  setLatitude: (value: number) => void;
  setLongitude: (value: number) => void;
  setPlaceId: (value: string) => void;
  setUnitNumber: (value: string) => void;
  setAddressType: (value: string) => void;
  setBuildingType: (value: string) => void;
  setBlockNumber: (value: string) => void;
  setBlockName: (value: string) => void;
  setStreet: (value: string) => void;
  setAddress1: (value: string) => void;
  setAddress2: (value: string) => void;
  setAddress3: (value: string) => void;
  setCity: (value: string) => void;
  setSuburb: (value: string) => void;
  setPostalCode: (value: string) => void;
  setProvince: (value: string) => void;
  handleUpdateAddress: () => void;
  isCreatingAddress: boolean;
  handleCreateAddress: () => void;
  special_instruction?: string;
  isUpdatingAddress?: boolean;
}

const AddressModal: React.FC<AddressModalProps> = ({
  visible,
  onClose,
  street,
  city,
  suburb,
  setSuburb,
  province,
  postalCode,
  isProcessing,
  isModalVisible,
  setStreet,
  setCity,
  setPostalCode,
  setProvince,
  handleUpdateAddress,
  addressType,
  setAddressType,
  buildingType,
  setBuildingType,
  longitude,
  setLongitude,
  latitude,
  setLatitude,
  setPlaceId,
  street_number,
  setStreetNumber,

  businessParkOrResidentialComplexName,
  setBusinessParkOrResidentialComplexName,
  buildingNameOrNumber,
  setBuildingNameOrNumber,
  blockNameOrNumber,
  setBlockNameOrNumber,
  unitNameOrNumber,
  setUnitNameOrNumber,
  isCreatingAddress,
  handleCreateAddress,
  special_instruction,
  isUpdatingAddress,
}) => {
  const [form] = Form.useForm();
  const { notify } = useNotification();

  const [location, setLocation] = useState<Coordinates | null>(null);
  const autocompleteRef = useRef<google.maps.places.Autocomplete | null>(null);
  const [error, setError] = useState<string | null>(null);

  // const isSupportedCity = (cityName: string): boolean => {
  //   const supportedCities = ["durban", "johannesburg", "cape town"];
  //   const normalizedCity = cityName.toLowerCase().trim();
  //   return supportedCities.some((supportedCity) =>
  //     normalizedCity.includes(supportedCity)
  //   );
  // };

  const isSupportedProvince = (provinceName: string): boolean => {
    const supportedProvinces = ["gauteng", "western cape", "kwazulu-natal"];
    const normalizedProvince = provinceName.toLowerCase().trim();
    return supportedProvinces.includes(normalizedProvince);
  };

  const handlePlaceChanged = () => {
    if (autocompleteRef.current) {
      const place = autocompleteRef.current.getPlace();

      if (place.geometry) {
        const lat = place.geometry.location?.lat();
        const lng = place.geometry.location?.lng();

        if (lat && lng) {
          setLocation({ latitude: lat, longitude: lng });
          setStreet(place.formatted_address || "");
          setLatitude(lat);
          setLongitude(lng);

          const placeId = place.place_id || "";
          setPlaceId(placeId);
   
          const addressComponents = place.address_components;

          if (addressComponents) {
            const postalCodeComponent = addressComponents.find((component) =>
              component.types.includes("postal_code")
            );
            const cityComponent = addressComponents.find((component) =>
              component.types.includes("locality")
            );
            const provinceComponent = addressComponents.find((component) =>
              component.types.includes("administrative_area_level_1")
            );
            const suburbComponent = addressComponents.find(
              (component) =>
                component.types.includes("sublocality") ||
                component.types.includes("sublocality_level_1")
            );

            const streetNumberComponent = addressComponents.find((component) =>
              component.types.includes("street_number")
            );

            const cityName = cityComponent?.long_name || "";
            setPostalCode(postalCodeComponent?.long_name || "");
            setCity(cityName);
            setProvince(provinceComponent?.long_name || "");
            setSuburb(suburbComponent?.long_name || "");
            setStreetNumber(streetNumberComponent?.long_name || "");

            // const cityName = cityComponent?.long_name || "";
            const provinceName = provinceComponent?.long_name || "";
            // Show a warning if the selected city is not supported
            if (provinceName && !isSupportedProvince(provinceName)) {
              notify(
                "We currently only deliver to Gauteng, Western Cape, and KwaZulu-Natal. " +
                  "You can continue to save this address, but delivery may not be available. " +
                  "Please consider visiting our store locator",
                "warn",
                [{ "store locator": "/store-locator" }, "for pickup options."]
              );
            }



            form.setFieldsValue({
              postal_code: postalCodeComponent?.long_name || "",
              street: place.formatted_address || "",
              city: cityName,
              province: provinceComponent?.long_name || "",
              suburb: suburbComponent?.long_name || "",
              street_number: streetNumberComponent?.long_name || "",
              addressType: addressType,
              buildingType: buildingType,
              business_Park_or_residential_complex_name:
                businessParkOrResidentialComplexName,
              unitNameOrNumber: unitNameOrNumber,
              buildingNameOrNumber: buildingNameOrNumber,
            });
          }
        }
      }
    }
  };

  useEffect(() => {
    form.setFieldsValue({
      postalCode: postalCode || "",
      street: street || "",
      city: city || "",
      province: province || "",
      suburb: suburb || "",
      street_number: street_number || "",
      addressType: addressType || "",
      buildingType: buildingType || "",
      buildingNameOrNumber: buildingNameOrNumber || "",
      businessParkOrResidentialComplexName:
        businessParkOrResidentialComplexName || "",
      unitNameOrNumber: unitNameOrNumber || "",
    });
  }, [
    street,
    city,
    suburb,
    postalCode,
    province,
    form,
    addressType,
    buildingType,
    businessParkOrResidentialComplexName,
    unitNameOrNumber,
    street_number,
    buildingNameOrNumber,
  ]);

  useEffect(() => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          setLocation({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          });
          setError(null);
        },
        (err) => {
          setError(err.message);
        }
      );
    } else {
      setError("error");
    }
  }, []);

  return (
    <Modal
      title={isUpdatingAddress ? "Update Address" : "Add New Address"}
      visible={isModalVisible ? isModalVisible : isCreatingAddress}
      onCancel={onClose}
      onOk={() => form.submit()}
      footer={null}
      width={700}
      height={500}
      bodyStyle={{ maxHeight: "550px", overflowY: "auto" }}>
      <Form
        form={form}
        onFinish={isModalVisible ? handleUpdateAddress : handleCreateAddress}>
        <div>
          {error && <p>Error: {error}</p>}
          {location ? (
            <GoogleMap
              center={{ lat: location.latitude, lng: location.longitude }}
              zoom={13}
              mapContainerStyle={{ height: "300px", width: "100%" }}>
              <Marker
                position={{ lat: location.latitude, lng: location.longitude }}
              />
            </GoogleMap>
          ) : (
            <p>No location found</p>
          )}
        </div>

        <section className="md:space-x-4">
          <div className="w-full">
            <SelectOption
              title="Address Type"
              value={addressType}
              setValue={setAddressType}
              placeholder="Select Address Type"
              options={[
                { value: "Residential", label: "Residential" },
                { value: "Business", label: "Business" },
              ]}
              required={true}
              name="addressType"
            />
          </div>
        </section>

        {addressType === "Residential" && (
          <div>
            <section className="md:space-x-4 mt-3">
              <Autocomplete
                onLoad={(autocomplete) =>
                  (autocompleteRef.current = autocomplete)
                }
                onPlaceChanged={handlePlaceChanged}
                options={{
                  componentRestrictions: { country: "ZA" },
                }}>
                <div className="w-full text-white">
                  <TextInput
                    title="Physical Address*"
                    placeholder="Street"
                    inputValue={street || ""}
                    setInputValue={setStreet}
                    required={true}
                  />
                </div>
              </Autocomplete>
            </section>

            <section className="flex flex-col md:flex-row md:space-x-4 mb-[12px]">
              <div className="w-full">
                <SelectOption
                  title="Building Type"
                  value={buildingType}
                  setValue={setBuildingType}
                  placeholder="Select Building Type"
                  options={[
                    { value: "House", label: "House" },
                    { value: "Complex", label: "Complex" },
                  ]}
                  required={true}
                  name="buildingType"
                />
              </div>

              {/* Only show unit number for Complex */}
              {buildingType === "Complex" && (
                <div className="w-full">
                  <TextInput
                    name="unitNameOrNumber"
                    title={`Unit Number`}
                    placeholder={`Enter Unit Number`}
                    inputValue={unitNameOrNumber}
                    setInputValue={setUnitNameOrNumber}
                    required={true}
                  />
                </div>
              )}
            </section>

            {/* Physical Address - shown for both House and Complex */}

            {/* Only show building name for Complex */}
            {buildingType === "Complex" && (
              <div>
                <section className="flex flex-col md:flex-row md:space-x-4 mt-[4px]">
                  <div className="w-full">
                    <TextInput
                      name="buildingNameOrNumber"
                      title={`Building Name & Number`}
                      placeholder={`Enter building name & number`}
                      inputValue={buildingNameOrNumber}
                      setInputValue={setBuildingNameOrNumber}
                      required={true}
                    />
                  </div>
                </section>
              </div>
            )}
          </div>
        )}

        {addressType === "Business" && (
          <div>
            <section className="md:space-x-4 mt-3">
              <Autocomplete
                onLoad={(autocomplete) =>
                  (autocompleteRef.current = autocomplete)
                }
                onPlaceChanged={handlePlaceChanged}
                options={{
                  componentRestrictions: { country: "ZA" },
                }}>
                <div className="w-full text-white">
                  <TextInput
                    title="Physical Address*"
                    placeholder="Street"
                    inputValue={street || ""}
                    setInputValue={setStreet}
                    required={true}
                  />
                </div>
              </Autocomplete>
            </section>
            <section>
              <section className="flex flex-col md:flex-row md:space-x-4 mt-[4px]">
                <div className="w-full">
                  <TextInput
                    title={`Building or Business Park Name (optional)`}
                    placeholder={`Building or Business Park Name (optional)`}
                    inputValue={buildingNameOrNumber}
                    setInputValue={setBuildingNameOrNumber}
                  />
                </div>
              </section>
            </section>
            <section className="flex flex-col md:flex-row md:space-x-4">
              <div className="w-full">
                <TextInput
                  type="text"
                  title="Office/Unit/Floor Number (optional):
"
                  placeholder="Enter Building Name & Number (optional)"
                  inputValue={blockNameOrNumber}
                  setInputValue={setBlockNameOrNumber}
                />
              </div>
            </section>
          </div>
        )}

        {/* Block Name is optional and shown for all types */}

        <div>
          <section className="flex flex-col md:flex-row md:space-x-4">
            <div className="w-full p-2 text-white">
              <TextInput
                title="Suburb"
                placeholder="Suburb"
                inputValue={suburb || ""}
                setInputValue={setSuburb}
              />
            </div>
            <div className="w-full p-2 text-white">
              <TextInput
                title="City"
                placeholder="City"
                inputValue={city || ""}
                setInputValue={setCity}
              />
            </div>
          </section>
          <section className="flex flex-col md:flex-row md:space-x-4">
            <div className="w-full p-2 text-white">
              <TextInput
                title="Province"
                placeholder="Province"
                inputValue={province || ""}
                setInputValue={setProvince}
              />
            </div>
            <div className="w-full p-2 text-white">
              <TextInput
                title="Postal Code"
                placeholder="Postal Code"
                inputValue={postalCode || ""}
                setInputValue={setPostalCode}
              />
            </div>
          </section>
        </div>
      </Form>

      <section className="text-center mt-4">
        {isProcessing ? (
          <Loader />
        ) : (
          <SecondaryButton
            onClick={() => form.submit()}
            label={isUpdatingAddress ? "Update Address" : "Add New Address"}
          />
        )}
      </section>
    </Modal>
  );
};

export default AddressModal;
